import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';

import { useCallback, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import messages from './messages';
import { AutomationRulesContext } from './context';
import { useOpenRuleDrawer } from './hooks/use-open-rule-drawer';
import { EventSourceStrings } from '../../../tracking/tracking-constants';
import { AutomationRulesSteps, useTrackAutomationRulesWorkflow } from './hooks/use-track-automation-rules-workflow';
import style from './style.module.less';

export const NewRuleButton = () => {
  const { defaultNewAction } = useContext(AutomationRulesContext);
  const openRuleDrawer = useOpenRuleDrawer();
  const trackStart = useTrackAutomationRulesWorkflow(AutomationRulesSteps.START);
  const openDrawer = useCallback(() => {
    openRuleDrawer({
      rule: { active: true, name: '', orderRuleActions: [defaultNewAction], isNew: true },
      name: '',
    });
    trackStart({
      source: EventSourceStrings.NEW_RULE_BUTTON,
      isAiGenerated: false,
    });
  }, [openRuleDrawer, defaultNewAction, trackStart]);
  return (
    <>
      <Button className={style['create-button']} onClick={openDrawer} theme='primary'>
        <FontAwesomeIcon className={style['create-icon']} icon={faPlus} />
        <FormattedMessage {...messages.createARule} />
      </Button>
    </>
  );
};
